import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { t } from "../app/Translate";
import './CountrySelect.css';

const countries = [
  { code: "es", name: t("countries.es"), flag: "https://flagcdn.com/w20/es.png" },
  { code: "co", name: t("countries.co"), flag: "https://flagcdn.com/w20/co.png" },  
  { code: "en", name: t("countries.us"), flag: "https://flagcdn.com/w20/us.png" },
];

interface CountryDropdownProps {
  selectedCode?: string; // parámetro opcional para país preseleccionado
}

const CountryDropdown: React.FC<CountryDropdownProps> = ({ selectedCode }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(countries[0]);
  const navigate = useNavigate();

  // ✅ Si llega un código de país por props, lo usamos
  useEffect(() => {
    if (selectedCode) {
      const found = countries.find((c) => c.code === selectedCode);
      if (found) setSelected(found);
    }
  }, [selectedCode]);

  const handleSelect = (country: typeof countries[0]) => {
    setSelected(country);
    setOpen(false);
    navigate(`/${country.code}`); // redirige con el código

    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "auto" }); // sube al inicio
      window.location.reload();
    }, 50);
  };

  return (
    <div className="country-container">
      {/* Botón principal */}
      <button className="dropdown-button" onClick={() => setOpen(!open)}>
        <div className="dropdown-body">
          <img src={selected.flag} alt={selected.name}/>
          <span>{selected.name}</span>
        </div>
        <motion.span
          animate={{ rotate: open ? 180 : 0 }}
          className="dropdown-arrow"
        >
          ▼
        </motion.span>
      </button>

      {/* Lista desplegable */}
      <AnimatePresence>
        {open && (
          <motion.ul
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="dropdown-list"
          >
            {countries.map((c) => (
              <li
                key={c.code}
                className="dropdown-items"
                onClick={() => handleSelect(c)}
              >
                <img src={c.flag} alt={c.name} className="w-6 h-4 mr-2" />
                <span className="text-gray-700">{c.name}</span>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CountryDropdown;
